import type { RequestParameters } from 'maplibre-gl';

const TILES_URL: string = import.meta.env.VITE_MAP_TILES_URL ?? '';
const TILES_KEY: string = import.meta.env.VITE_MAP_TILES_KEY ?? '';

export const MAP_STYLE_URL = `${TILES_URL}/style/${import.meta.env.VITE_MAP_STYLE ?? 'streets-flat'}`;

/**
 * The Pysae tiler serves the style, tiles, sprites and glyphs only to a request
 * carrying its key; nothing else, the group logos above all, must receive it.
 */
export function withTilesKey(url: string): RequestParameters {
  if (!TILES_URL || !url.startsWith(`${TILES_URL}/`)) return { url };
  return { url, headers: { apikey: TILES_KEY } };
}
